riot.tag2('gb-variant-switcher', '<a if="{_scope.variants.length > 1}" each="{variant, i in _scope.variants}" class="gb-product__variant-link" onclick="{_scope.switchVariant}" data-index="{i}"> {i} </a>', '', '', function(opts) {
    this._scopeTo('gb-product');
});



/** WEBPACK FOOTER **
 ** ./src/tags/product/gb-variant-switcher.tag.html
 **/